import React, { useState } from 'react';
import { CgArrowLongRight } from 'react-icons/cg';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { businessLogic } from '../../lib/constants';
import TechGridBackground from '../TechGridFloor/TechGridBackgroundLazy';

const HomeTwoSingleFeature = ({ icon, title, description, url, image }) => {
   const [isHovered, setIsHovered] = useState(false);

   return (
      <>
         <div
           className="features__item features__item-2 white-bg fix mb-30"
           onMouseEnter={() => setIsHovered(true)}
           onMouseLeave={() => setIsHovered(false)}
         >
            <div className="features__thumb-2" style={{ opacity: isHovered ? 1 : 0, transition: 'opacity 0.3s ease', overflow: 'hidden' }}>
               {isHovered && (
                  <TechGridBackground
                    meshProps={{
                     color: "#6a60f0",
                     opacity: 0.05,
                     amp: 0.035,
                     freq: 0.9,
                     rotation: [0, 0, 0],
                     position: [0, 0, 0],
                     planeArgs: [10, 10, 180, 180],
                   }}
                   camera={{ position: [0, 0, 6.2], fov: 55 }}
                   dpr={[1, 1.4]}
                 />
               )}
            </div>
             <div className="features__content-2">
                <div className="features__icon features__icon-2">
                   <i > {icon} </i>
                </div>
                <h3>{title}</h3>
                <p> {description} </p>
               <div className="features__btn-2">
                  <Link to={url} className="link-btn">
                     <i > <CgArrowLongRight /> </i>
                     <i > <CgArrowLongRight /> </i>
                  </Link>
               </div>
            </div>
         </div>
      </>
   );
};

export default HomeTwoSingleFeature;

export const HomeTwoServicesGrid = () => {
   const { t } = useTranslation();

   const services = [
      {
         icon: '1',
         title: t('home_services_title_mobileapps'),
         description: t('home_services_subtitle_mobileapps'),
         destiny: businessLogic.mobile_landing,
      },
      {
         icon: '2',
         title: t('home_services_title_backend'),
         description: t('home_services_subtitle_backend'),
         destiny: businessLogic.backend_landing,
      },
      {
         icon: '3',
         title: t('home_services_title_consulting'),
         description: t('home_services_subtitle_consulting'),
         destiny: businessLogic.consulting_landing,
      },
      {
         icon: '8',
         title: t('home_services_title_database'),
         description: t('home_services_subtitle_database'),
         destiny: businessLogic.database_landing,
      },
      {
         icon: '4',
         title: t('home_services_title_analytics'),
         description: t('home_services_subtitle_analytics'),
         destiny: businessLogic.data_landing,
      },
      {
         icon: '5',
         title: t('home_services_title_uiuxdesign'),
         description: t('home_services_subtitle_uiuxdesign'),
         destiny: businessLogic.uiux_landing,
      },
      {
         icon: '6',
         title: t('home_services_title_webapps'),
         description: t('home_services_subtitle_webapps'),
         destiny: businessLogic.webapps_landing,
      },
      {
         icon: '7',
         title: t('home_services_title_saas'),
         description: t('home_services_subtitle_saas'),
         destiny: businessLogic.saas_landing,
      },
   ];

   return (
      <div className="row">
         {services.map((service) => (
            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6" key={service.title}>
               <a href={service.destiny} target="_blank" rel="noreferrer">
                  <div className="services__item mb-90">
                     <div className="services__icon mb-35">
                        <img
                           src={`assets/img/icon/services/service-${service.icon}.png`}
                           alt="services"
                           height={65}
                        />
                     </div>
                     <div className="services__content">
                        <h3>{service.title}</h3>
                        <p style={{ fontSize: 16 }}>{service.description}</p>
                     </div>
                  </div>
               </a>
            </div>
         ))}
      </div>
   );
};
